<template>
    <el-table stripe v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
        :header-cell-style="headCellStyle" :height="tableHeight" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column :label="$t('integration.name')" show-overflow-tooltip prop="name" />
        <el-table-column :label="$t('integration.code')" show-overflow-tooltip prop="code" />
        <el-table-column :label="$t('public.status')" show-overflow-tooltip prop="status">
            <template #default="{ row }">
                <span>
                    {{ statusText(row.status) }}
                </span>
            </template>
        </el-table-column>
        <el-table-column :label="$t('public.table_desc')" show-overflow-tooltip prop="description" />
        <el-table-column :label="$t('public.table_operation')" show-overflow-tooltip prop="Operation" width="100" align="center">
            <template #default="{ row }">
                <el-button type="text" icon="el-icon-tickets" size="small" :title="$t('public.tbopt_detail')"
                    @click="detailFn(row)">
                </el-button>
                <el-button @click="delFn(row)" :title="$t('public.tbopt_delete')" icon="el-icon-delete" type="text"
                    size="small">
                </el-button>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
export default {
    props: ['loading', 'tableData', 'statusParam'],
    data() {
        return {
            tableHeight: 'calc(100% - 60px)',
        }
    },
    methods: {
        handleSelectionChange(arg) {
            this.$emit('choozeTableFn', arg)
        },
        detailFn(row) {
            this.$emit('detailFn', row)
        },
        delFn(row) {
            this.$emit('delFn', row)
        },
        statusText(status) {
            let str;
            for (let item of this.statusParam) {
                if (String(status) === item.value) {
                    str = this.$t(item.label);
                    break;
                }
            }
            return str
        }
    }
}
</script>

<style>
</style>